module.exports = __webpack_public_path__ + "static/media/mareges_horizontal.dea1c2b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mareges_horizontal.png
// module id = 1848
// module chunks = 0